import { render } from "./BulkActionProgress.vue?vue&type=template&id=2d44337b"
import script from "./BulkActionProgress.vue?vue&type=script&lang=js"
export * from "./BulkActionProgress.vue?vue&type=script&lang=js"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__